import React from "react";
import TableWithCustomSearch from "../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { useSelector } from "react-redux";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ReactTooltip from "react-tooltip";

const LeadActivityTable = () => {
  const tableLoading = useSelector((state) => state.leadActivity.tableLoading);
  const {
    data = [],
    colHeaders = [],
    colHeaderTooltips = [],
    columns = [],
    rawDataLink
  } = useSelector((state) => state.leadActivity.tableData.tableInfo || {});
  const tooltipId = "lead-activity-table-header-tooltip";

  const columnHeaderSlot = colHeaderTooltips.reduce((acc, column) => {
    acc[column.columnHeader] = (
      <div className="d-inline" data-for={tooltipId} data-tip={column?.tooltip}>
        {column?.label}
      </div>
    );
    return acc;
  }, {});

  return tableLoading ? (
    <LoadingAnimation />
  ) : (
    <div>
      {data?.length ? (
        <>
          <TableWithCustomSearch
            data={data}
            colHeaders={colHeaders}
            columns={columns}
            rawDataLink={rawDataLink}
            fileName="lead-activity"
            itemsPerPage={10}
            columnHeaderSlot={columnHeaderSlot}
            hideFirstCol
          />
          <ReactTooltip id={tooltipId} />
        </>
      ) : (
        <div className="error">No data for selected period.</div>
      )}
    </div>
  );
};

export default LeadActivityTable;
